<script>
    import {eventBus} from "../core/event-bus-store.js";
    import Button from "./Button.svelte";
    import {get} from "svelte/store";
    import {mediaUrlStore} from "../core/app-store.js";

    export let tenantKey = '';

    const mediaUrl = get(mediaUrlStore);

    let lightboxImageSrc = null;
    let lightboxImageTitle = null;
    let lightboxImageText = null;


    eventBus.subscribe(e => {

        if (e && e.length > 0) {

            e.forEach(x => {
                if (x?.event === 'openFullscreen' && x?.payload?.media?.type === 'photo') {

                    lightboxImageSrc = `${mediaUrl}${x.payload.media.ref || tenantKey}${x.payload.media.url}`;
                    lightboxImageTitle = x?.payload?.media.title;
                    lightboxImageText = x?.payload?.media.text;
                }
            });
        }
    });

    function close() {

        lightboxImageSrc = null;
        lightboxImageTitle = null;
        lightboxImageText = null;
    }

</script>
<style>

.lightbox-container {
    position: fixed;
    z-index: 10000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    pointer-events: none;
    opacity: 0;

    transition: opacity .3s ease;
}
.lightbox-container--open {
    background: #000000;
    pointer-events: all;
    opacity: 1;
}
.lightbox {
    position: relative;
    display: flex;
    background: #4e4e4e;
    padding: 1px;
    box-shadow: 0 .25rem 1rem 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    overflow: hidden;
    border-radius: 2px;
    pointer-events: all;
    max-height: 100%;
    max-width: 100%;
    transform: translate(0, 15%) scale(.95);
    transition: transform .3s ease;
}
.lightbox-container--open .lightbox {
    transform: translate(0, 0) scale(1);
}
.lightbox img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 1px;
}
.title-container {
    position: absolute;
    z-index: 10;
    bottom: 0;
    left: 0;
    padding: .75rem 1rem;
    width: 100%;
    background: #00000055;
    display: flex;
    flex-direction: column;
    gap: .5em;
    line-height: 1.25;
    color: var(--main-font-color);
}
.title-container .title {
    font-family: PT Mono, sans-serif;
}
.title-container .text {
    max-width: 768px;
    opacity: .8;
    line-height: 1.5;
}
.close-button-container {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 1rem;
}

@media (max-width: 767px) {
    .lightbox-container {
        padding: .5rem;
    }
    .lightbox {
        position: unset;
        flex-direction: column;
        background: none;
    }
    .title-container {
        position: unset;
        padding-left: 0;
        padding-right: 0;
        background: none;
    }
}

</style>

<div class="lightbox-container"
     class:lightbox-container--open={ lightboxImageSrc != null }
     on:click={() => close()} >

    <div class="lightbox">
        <img src={ lightboxImageSrc } loading="lazy">

        {#if (lightboxImageTitle || lightboxImageText) }
            <div class="title-container">
                {#if (lightboxImageTitle) }
                    <div class="title label">{ lightboxImageTitle }</div>
                {/if}

                {#if (lightboxImageText) }
                    <div class="text">{ lightboxImageText }</div>
                {/if}
            </div>
        {/if}
    </div>

    <div class="close-button-container hide-on-desktop">
        <Button label="Закрыть" type="secondary--alt" on:click={() => close()}></Button>
    </div>
</div>
